import { render, staticRenderFns } from "./IncomeResult.vue?vue&type=template&id=0983f2ea&"
import script from "./IncomeResult.vue?vue&type=script&lang=js&"
export * from "./IncomeResult.vue?vue&type=script&lang=js&"
import style0 from "./IncomeResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports